import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { defaultBrandKit } from "@redotech/redo-model/brand-kit";
import {
  getReviewsFormDefault,
  ReviewsFormValue,
} from "@redotech/redo-web/reviews-form/review-form-types";
import { memo } from "react";
import { RedoShopifyRpcClientContext } from "../../client/redo-shopify-rpc-client";
import { ReviewsSurveyModal } from "./reviews-survey-modal";

const formDefault = getReviewsFormDefault(defaultBrandKit);

export const ReviewSurvey = memo(function ReviewSurvey() {
  const rpcClient = useRequiredContext(RedoShopifyRpcClientContext);

  const formLoad = useLoad(async () => {
    const reviewForm = await rpcClient.getActiveReviewForm(null);
    if (!reviewForm) {
      return formDefault;
    } else {
      return reviewForm.formData;
    }
  }, []);

  // REVIEWS-TODO TODO-bcarper I wrote an "as" here because BrandKit and zod are not playing nice -- fix this
  return formLoad.value ? (
    <ReviewsSurveyModal reviewsFormValue={formLoad.value as ReviewsFormValue} />
  ) : null;
});
